import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ViewBaseComponent } from '../view-base/view-base.component';

@Component({
  selector: 'view-menu',
  templateUrl: './view-menu.component.html',
  styleUrls: ['./view-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ViewMenuComponent extends ViewBaseComponent {
  open = false;

  itemClicked() {
    this.open = false;
  }
}
